module.exports = __webpack_public_path__ + "img/9.1d3d29ab.jpg";